import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';

const Modal = ({ isOpen, onClose, children, showCloseButton = true }) => {
  const overlayRef = useRef(null);

  // Handle clicks outside the modal content to close it
  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  // Handle 'Escape' key press to close the modal
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      // Prevent scrolling of the background content when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  // Ensure a portal container exists (fallback if not present in index.html)
  const modalRoot = document.getElementById('modal-root') || (() => {
    const el = document.createElement('div');
    el.id = 'modal-root';
    document.body.appendChild(el);
    return el;
  })();

  // Use React Portal to render the modal at the root of the document
  return ReactDOM.createPortal(
    <div 
      className={`${styles.modalOverlay} ${isOpen ? styles.open : ''}`} 
      ref={overlayRef} 
      onClick={handleOverlayClick}
    >
      <div className={styles.modalContent}>
        {showCloseButton && (
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        )}
        <div className={styles.modalBody}>
          {children}
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
